import { render, staticRenderFns } from "./schTchDaily.vue?vue&type=template&id=713a0ef7&"
import script from "./schTchDaily.vue?vue&type=script&lang=js&"
export * from "./schTchDaily.vue?vue&type=script&lang=js&"
import style0 from "./schTchDaily.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports